<script setup>
import { computed, reactive, ref } from "vue";
const key = 'COUNSTRY';

const form_ref = ref(null)
const callback_1 = ref(null)
const dialog_show = ref(false)
const pick_show = ref(false)
const form = reactive({
  country: 'US',
  city: null,
  street: null,
  zip: null
})

const open = (cb1) => {
  reset()
  callback_1.value = cb1
  dialog_show.value = true
}
const close = () => {
  dialog_show.value = false
}
const reset = () => {
  form.country = 'US'
  form.city = null
  form.street = null
  form.zip = null
}
const submit_form = () => {
  form_ref.value.validate()
    .then((res) => {
      callback_1.value(form)
    }).catch((rej) => {
      console.error(rej)
    })
}
const check_country = (selectedValues) => {
  form.country = selectedValues.sign
  pick_show.value = false
}
const format_country_list = computed(() => {
  return JSON.parse(localStorage.getItem(key))
})
const filter_country_icon = computed(() => {
  return format_country_list.value.filter((it) => {
    return it.sign === form.country
  })
})
defineExpose({
  open
})
</script>

<template>
  <van-dialog
    v-model:show="dialog_show"
    close-on-click-overlay
    @cancel="close"
  >
    <van-form ref="form_ref">
      <van-cell-group inset>
        <!-- 国家输入框 -->
        <van-field
          clickable
          required
          is-link
          readonly
          label="Country/Region"
          name="picker"
          label-width="100%"
          class="this-field"
          @click="pick_show = true"
        >
          <template #input>
            <span class="icon-flag icon-img" :class="filter_country_icon[0].icon" />
            <span>{{ filter_country_icon[0].name }}</span>
          </template>
        </van-field>
        <!-- 国家输入框 联动选项框 -->
        <van-popup v-model:show="pick_show" position="bottom" teleport="body">
          <van-picker
            :columns="format_country_list"
            @confirm="check_country"
            @cancel="pick_show = false"
          >
            <template #option="option">
              <!-- {{ option.icon }} -->
              <span class="icon-flag icon-img" :class="option.icon" />
              {{ option.name }}
            </template>
          </van-picker>
        </van-popup>
        <!-- 城市 -->
        <van-field
          v-model="form.city"
          required
          maxlength="50"
          name="City"
          label="City"
          placeholder="Please input City"
          :rules="[{ required: true, message: 'Please input City' }]"
        />
        <!-- 街道 -->
        <van-field
          v-model="form.street"
          required
          maxlength="80"
          name="Street"
          label="Street"
          placeholder="Please input Street"
          :rules="[{ required: true, message: 'Please input City' }]"
        />
        <!-- Post Code -->
        <van-field
          v-model="form.zip"
          required
          maxlength="100"
          name="Post code"
          label="Post code"
          placeholder="Please input Post code"
          :rules="[{ required: true, message: 'Please input City' }]"
        />
      </van-cell-group>
      <!-- <div style="margin: 16px;"> -->
      <!-- </div> -->
    </van-form>
    <template #footer>
      <van-button round block type="primary" @click="submit_form">
        Continue
      </van-button>
    </template>
  </van-dialog>
</template>

<style lang="scss" scoped>
@import 'components/SelectCountry/css/counstry.icon.scss';
.this-field {
    display: grid;
    grid-template-columns: 95% 5%;
    :deep(.van-field__label) {
        grid-column: 1 / span 2;
    }
}
.w-100 {
    width: 100%;
}
</style>